import { render } from "./tech.vue?vue&type=template&id=33d3516a&scoped=true"
import script from "./tech.vue?vue&type=script&lang=js"
export * from "./tech.vue?vue&type=script&lang=js"

import "./tech.vue?vue&type=style&index=0&id=33d3516a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d3516a"]])

export default __exports__